<div *ngIf="value">
  <span class="badge bg-secondary me-2" *ngFor="let item of value.split(',')"> {{item}}</span>

</div>